/*
 * @LastEditors: boqodo
 * @Author: boqodo
 * @Date: 2025-04-09 00:37:17
 * @LastEditTime: 2025-04-13 19:59:06
 * @Description: filecontent
 * @FilePath: /h5-astx-app/src/data/textbooks/index.js
 */
// 课本数据索引文件
import grade3Term1 from './grade3_term1.json';
import grade5Term1 from './grade5_term1.json';
import grade5Term2 from './grade5_term2.json';

// 课本数据映射表
const textbookMap = {
  '三年级': {
    '上册': grade3Term1
  },
  '五年级': {
    '上册': grade5Term1,
    '下册': grade5Term2
  },
};

// 获取指定年级和学期的课本数据
export const getTextbook = (grade, term) => {
  if (textbookMap[grade] && textbookMap[grade][term]) {
    return textbookMap[grade][term];
  }
  return null;
};

// 获取所有可用年级
export const getAvailableGrades = () => {
  return Object.keys(textbookMap);
};

// 获取指定年级的可用学期
export const getAvailableTerms = (grade) => {
  if (textbookMap[grade]) {
    return Object.keys(textbookMap[grade]);
  }
  return [];
};

// 获取所有单词（用于随机选择功能）
export const getAllWords = (gradeFilter = null, termFilter = null) => {
  let allWords = [];
  
  Object.entries(textbookMap).forEach(([grade, terms]) => {
    // 如果指定了年级过滤，则跳过不匹配的年级
    if (gradeFilter && grade !== gradeFilter) return;
    
    Object.entries(terms).forEach(([term, textbook]) => {
      // 如果指定了学期过滤，则跳过不匹配的学期
      if (termFilter && term !== termFilter) return;
      
      // 收集所有单元的单词
      textbook.units.forEach(unit => {
        unit.words.forEach(word => {
          allWords.push({
            ...word,
            grade,
            term,
            unitName: unit.name
          });
        });
      });
    });
  });
  
  return allWords;
};

export default textbookMap;